import { array, struct } from 'io-ts/Decoder';

import { Id as UsageId } from '../../../../whole-house/usage/Id';

export const Request = struct({
	usageIds: array(UsageId),
});
